export const showNotification = (notificationType) => {
  type: "SHOW_NOTIFICATION", notificationType;
};

export const hideNotification = () => {
  return {
    type: "HIDE_NOTIFICATION",
  };
};



// WEBPACK FOOTER //
// ./src/actions/notifications.actions.js